module.exports = __webpack_public_path__ + "static/media/malawi-flag-round-small.bc9fb9c5.jpg";